import './index.css';
export { default as Footer } from './footer';
export {AboutUs,PricingStructure,PrivacyPolicy,RefundAndCancellation,TermsAndConditions} from './PaymentPolicy';
